const searchInitialState = {
  text: "",
  type: "ALL",
};
export default searchInitialState;
